import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M8.25 6.5C8.25 6.08579 7.91421 5.75 7.5 5.75C7.08579 5.75 6.75 6.08579 6.75 6.5V17.5C6.75 17.9142 7.08579 18.25 7.5 18.25C7.91421 18.25 8.25 17.9142 8.25 17.5V6.5ZM17.5303 7.53033C17.8232 7.23744 17.8232 6.76256 17.5303 6.46967C17.2374 6.17678 16.7626 6.17678 16.4697 6.46967L11.4697 11.4697C11.1768 11.7626 11.1768 12.2374 11.4697 12.5303L16.4697 17.5303C16.7626 17.8232 17.2374 17.8232 17.5303 17.5303C17.8232 17.2374 17.8232 16.7626 17.5303 16.4697L13.0607 12L17.5303 7.53033Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
